export const UPDATE_FOODS = "UPDATE_FOODS"
export const ADD_FOODS = "ADD_FOODS"
export const DELETE_FOODS = "DELETE_FOODS"
export const CLEAR_FOODS = "CLEAR_FOODS"